import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Alert } from '../../alert/index.js';
import { Select, Label, Required } from '../formstyles.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { ALERT_VARIANTS } from '../../alert/constants.js';

var _templateObject;
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "select__Wrapper",
  componentId: "sc-axe9gc-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.baseSpacing;
});
const SelectField = /*#__PURE__*/forwardRef(function SelectField(_ref2, ref) {
  let {
    error,
    hideLabel = false,
    label,
    required,
    ...rest
  } = _ref2;
  return hideLabel ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Select, {
      "aria-label": label,
      hasError: error,
      ref: ref,
      required: required,
      ...rest
    }), error && /*#__PURE__*/jsx(Alert, {
      variant: ALERT_VARIANTS.ERROR,
      children: error
    })]
  }) : /*#__PURE__*/jsxs(Wrapper, {
    children: [/*#__PURE__*/jsxs(Label, {
      children: [/*#__PURE__*/jsx(Required, {
        required: required,
        children: label
      }), /*#__PURE__*/jsx(Select, {
        ref: ref,
        hasError: error,
        required: required,
        ...rest
      })]
    }), error && /*#__PURE__*/jsx(Alert, {
      variant: ALERT_VARIANTS.ERROR,
      children: error
    })]
  });
});

export { SelectField };
